import { makeStyles } from '@material-ui/core/styles';
import { NoteType } from './index';

const useStyles = makeStyles(({ typography, palette, variables }) => ({
  note: {
    display: 'flex',
    alignItems: 'center',
    padding: variables?.spacingA,
    paddingLeft: variables?.spacingB,
    paddingRight: variables?.spacingB,
    borderRadius: '14px',
    gap: variables?.spacingA,
    '& img': {
      marginRight: variables?.spacingD
    },
    [`&.align-center`]: {
      justifyContent: 'center'
    },
    [`&.align-left`]: {
      justifyContent: 'flex-start'
    },
    [`&.align-right`]: {
      justifyContent: 'flex-end'
    },
    [`&.note-${NoteType.Information}`]: {
      backgroundColor: palette.jet?.supportInfo02,
    },
    [`&.note-${NoteType.Warning}`]: {
      backgroundColor: palette.jet?.supportBrand02,
    },
    [`&.note-${NoteType.Default}`]: {
      backgroundColor: palette.jet?.borderDefault,
    },
    [`&.note-${NoteType.SupportWarning}`]: {
      backgroundColor: palette.jet?.supportWarning02,
      alignItems:'flex-start',
      '& > i': {
        paddingTop: '2px'
      }
    },

    '& span': {
      fontSize: typography.body2.fontSize,
      lineHeight: typography.body2.lineHeight,
      //minHeight: '24px',
      display: 'flex',
      alignItems: 'center'
    },
  },
}));

export default useStyles;
